import {
    FETCH_COLLECTIONS, FETCH_STATISTICS
} from '../actions/types'


const INITIAL_STATE = {
    payPalCollectionsYtd: 0,
    payPalRefundsYtd: 0,
    stripeCollectionsYtd: 0,
    stripeRefundsYtd: 0,
    overallTotal: 0,
    year: 2020
};

export default (state = INITIAL_STATE, action ) => {
    switch(action.type) {
        case FETCH_COLLECTIONS: 
            return { ...state, ...action.payload}
        case FETCH_STATISTICS:
            return { ...state, ...action.payload}
        default: 
            return state;
    }
}